export interface QuestionOptions<TContent> {
  isSelfEvaluated: boolean
  customInstruction: (content: TContent) => string
}

export function defaultQuestionOptions<TContent>(): QuestionOptions<TContent> {
  return {
    isSelfEvaluated: false,
    customInstruction: (_) => ''
  }
}

export const QuestionOptionsPluginSymbol = Symbol.for("QuestionOptionsPlugin");
